import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import css_248z from './button-primary.scss.js';
import { PrimaryCta } from '../primary-cta/index.js';

class ButtonPrimary extends PrimaryCta {
    render() {
        return x `<button class="button-primary" type="${this.type}" ?disabled="${this.disabled}" @click="${this.handleClick}"><span>${this.label}</span></button>`;
    }
}
ButtonPrimary.styles = css_248z;
customElements.define('button-primary', ButtonPrimary);

export { ButtonPrimary };
